import { render, staticRenderFns } from "./proxyDetails.vue?vue&type=template&id=dd7ba95c&scoped=true&"
import script from "./proxyDetails.vue?vue&type=script&lang=js&"
export * from "./proxyDetails.vue?vue&type=script&lang=js&"
import style0 from "./proxyDetails.vue?vue&type=style&index=0&id=dd7ba95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7ba95c",
  null
  
)

export default component.exports